import { CalendarDays, LayoutDashboard, type LucideIcon } from "lucide-react";

type DashboardPageHeaderProps = {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  badge?: string;
  date?: string;
};

export function DashboardPageHeader({
  title,
  subtitle,
  icon: Icon = LayoutDashboard,
  badge,
  date,
}: DashboardPageHeaderProps) {
  return (
    <div className="theme-card p-5 md:p-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex items-start gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent-soft">
            <Icon size={22} className="text-accent-foreground" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">{title}</h1>
            {subtitle ? <p className="mt-1 text-sm text-muted">{subtitle}</p> : null}
          </div>
        </div>
        {(badge || date) && (
          <div className="flex flex-wrap items-center gap-3">
            {badge ? (
              <span className="inline-flex max-w-xs rounded-lg bg-accent-soft px-4 py-2 text-center text-xs font-semibold leading-snug text-accent-foreground">
                {badge}
              </span>
            ) : null}
            {date ? (
              <span className="inline-flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-2 text-sm text-muted-foreground">
                <CalendarDays size={16} className="text-primary" />
                {date}
              </span>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
